import { useSelector } from 'react-redux';

import {
  canDoOrderAction,
  canEditOrderField,
  isPolicyBoundRole,
  pickEditableOrderFields,
  resolveOrderEditPolicy,
} from '@modules/logic/orderEditPolicy';

const UNRESTRICTED = resolveOrderEditPolicy(null);

/**
 * Order edit policy of the logged-in user (see @modules/logic/orderEditPolicy).
 * Pure resolver for callers outside a component. Admins are never bound, even
 * when their user also carries the `gestore` role.
 */
export function resolveCallerOrderEditPolicy(user, currentManager) {
  if (!isPolicyBoundRole(user?.role)) return UNRESTRICTED;
  return resolveOrderEditPolicy(currentManager);
}

/**
 * UI side of the policy: disable fields and hide actions the manager may not
 * use. The API and firestore.rules enforce the same contract.
 */
export default function useOrderEditPolicy() {
  const user = useSelector((state) => state.user);
  const currentManager = useSelector((state) => state.currentManager);
  const policy = resolveCallerOrderEditPolicy(user, currentManager);
  return {
    policy,
    restricted: policy.restricted,
    canEditField: (field) => canEditOrderField(policy, field),
    can: (action) => canDoOrderAction(policy, action),
    pickEditable: (prev, patch) => pickEditableOrderFields(policy, prev, patch),
  };
}
